import React, { Component } from "react";
import { Link } from "react-router-dom";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

class Services2 extends Component {
  render() {
    var settings = {
      dots: true,
      arrows: true,
      speed: 3000,
      slidesToShow: 4,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2500,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            infinite: true,
          },
        },
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    };

    const ClickHandler = () => {
      window.scrollTo(10, 0);
    };

    const service = [
      {
        sIcon: "fi flaticon-lamp",
        title: "Custom Software Development",
        des: "We design intelligent software solutions that are built around your business goals, not the other way around.",
        link: "/service-single/custom-software-development",
      },
      {
        sIcon: "fi flaticon-edit",
        title: "Web Application Development",
        des: "From MVPs to enterprise-grade platforms, we build secure, scalable web apps with a focus on performance and UX.",
        link: "/service-single/web-application-development",
      },
      {
        sIcon: "fi flaticon-business",
        title: "Mobile App Development",
        des: "We create intuitive, high-performing mobile apps for iOS and Android that help you connect with your users everywhere.",
        link: "/service-single/mobile-app-development",
      },
      {
        sIcon: "fi flaticon-trophy",
        title: "IT Consulting and Technical Strategy",
        des: "Our experts guide your digital transformation with actionable insights and a focus on efficiency and scalability.",
        link: "/service-single/it-consulting",
      },
      {
        sIcon: "fi flaticon-startup",
        title: "IoT Solutions",
        des: "Connect, automate, and optimize your operations with scalable IoT solutions tailored to your industry needs.",
        link: "/service-single/iot-solutions",
      },
    ];

    return (
      <section
        className={`wpo-service-section section-padding ${this.props.srvClass}`}
      >
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="wpo-section-title">
                <span>Our Services</span>
                <h2>Explore Our Services</h2>
              </div>
            </div>
          </div>
          <div className="wpo-service-items wpo-service-slider owl-carousel">
            <Slider {...settings}>
              {service.map((service, sitem) => (
                <div className="col-lg-4 col-md-6 col-12" key={sitem}>
                  <div className="wpo-service-item">
                    <div className="wpo-service-icon">
                      <div className="icon">
                        <i className={service.sIcon}></i>
                      </div>
                    </div>
                    <div className="wpo-service-text">
                      <h2>
                        <Link onClick={ClickHandler} to={service.link}>
                          {service.title}
                        </Link>
                      </h2>
                      <p>{service.des}</p>
                    </div>
                  </div>
                </div>
              ))}
            </Slider>
          </div>
        </div>
      </section>
    );
  }
}

export default Services2;
